import React, { Fragment, useEffect, useState } from 'react';
import $ from "jquery";
import { Route, Link } from 'react-router-dom';
import NavLink from 'react-router-dom/NavLink';
import Forget from './Forget';
import Login from './Login';
import Register from './Register';
import store from '../../common/store';
import { logoutUser } from '../../common/actions/userActions';
import connect from 'react-redux/lib/connect/connect';
import { isEmpty, isMobilePage } from '../../common/cores';
import SideMenuBar from '../account/SideMenuBar';
import RightBar from '../account/RightBar';
import moment from 'moment';

// const activeStyle = {
//     textShadow: "rgb(255 255 255) 0px 0px 5px, rgb(78 203 255) 0px 0px 10px, rgb(0 0 255) 0px 0px 15px, rgb(0 138 255) 0px 0px 5px, rgb(0 138 255) 0px 0px 5px, rgb(78 78 255) 0px 0px 10px, rgb(0 138 255) 0px 0px 20px, rgb(0 138 255) 0px 0px 40px",
//     cursor: "pointer",
//     color: "rgb(213, 249, 255)",
// }

const menus = [
  {
    name: "출석",
    path: "/attendance",
    iconClassName: "icon-customer xi-check",
    value: 11
  },
  {
    name: "복권",
    path: "/lottery",
    iconClassName: "icon-customer xi-gift-o",
    value: 12
  },
  {
    name: "쿠폰",
    path: "/coupon",
    iconClassName: "icon-customer xi-coupon",
    value: 13
  },
  {
    name: "룰렛",
    path: "/roulette",
    iconClassName: "icon-customer xi-roullet",
    value: 14
  },
]

const Headbar = (props) => {
    const [showLogin, setShowLogin] = useState(false);
    const [showRegister, setShowRegister] = useState(false);
    const [showForget, setShowForget] = useState(false);
    const [time, setTime] = useState("");
    const [day, setDay] = useState("");
    const [showMenu, setShowMenu] = useState(false);
    const [path, setPath] = useState("");
    const [popup, setPopup] = useState(false);
    const [style, setStyle] = useState({});

    const { isAuthenticated, user, page, unreadNotes } = props;
    // const [state, dispatch] = useReducer(reducer, initialState); 
    // console.log(props);

    const onShowLogin = () => {
        setShowLogin(!showLogin);
    }

    const onShowRegister = () => {
        setShowRegister(!showRegister);
    }

    const onShowForget = () => {
        setShowForget(!showForget);
    }

    const onPopup = () => {
        setPopup(!popup);
    }

    const onLogout = () => {
      props.logoutUser();
      onShowLogin();
      onPopup();
    }

    const handleResize = () => {
        if (window.innerWidth <= 991) {
          setStyle({
            display: isAuthenticated ? 'none' : 'block',
          });
        } else {
          setStyle({
            display: 'block'
          });
        }
      };
    
    useEffect(() => {
      handleResize(); // 초기 화면 크기 확인
      window.addEventListener('resize', handleResize); // 리사이즈 이벤트 리스너 추가
  
      return () => {
        window.removeEventListener('resize', handleResize); // 리스너 제거
      };
    }, [isAuthenticated]);

    const visit = (
      <div className="login">
        <ul>
          <li>
            <Link to="/login">
              <img src="images/icon_my_01.png" alt=""/>로그인</Link>
            </li>
          <li><img src="images/line2.jpg" alt=""/></li>
          <li><Link to="/register"><img src="images/icon_my_02.png" alt=""/>회원 가입</Link></li>
        </ul>
      </div>
        )

    const logIn = (
      <div className="my">
        <ul>
          <button className="level-icon header-level">LV.{props.user.level}</button>
          <li className='header-level'>{ !isEmpty(props.user) && props.user.loginId } 님</li>
          <li className='header-level'>보유금액 : <span>{ !isEmpty(user.balance) ? Number(user.balance.money).toLocaleString() : "0"}</span> 원</li>
          <li className='header-level'>포인트 : <span>{!isEmpty(user.balance) ? Number(user.balance.rolling).toLocaleString() : "0"}</span> 원</li>
          <li className='header-level'><Link to="/messages" className="w-100">쪽지 (<span>{unreadNotes.length}</span>)</Link></li>
          {
            menus.map((menu, index) => {
              return ( <li key={index} className='header-level'><Link to={menu.path} className="w-100">{menu.name}</Link></li> )
            })
          }
          <div>
            <li className="onlyPC d-flex">
              <Link to="/point" className="w-100"><span className="utill_btn01">포인트전환</span></Link>&nbsp;&nbsp;
              <a onClick={onPopup}><span className="utill_btn02">로그아웃</span></a>
            </li>
          </div>
        </ul>
      </div>
        )
    return (
      <div className="my_wrap" style={isAuthenticated && window.innerWidth < 991 ? {display : 'none'} : {display : 'block'}}>
        <div className="my_box" style={{ height: !isAuthenticated && "50px" }}>
          {!isAuthenticated ?
              visit:
              logIn}
        </div>

        <div className="dialog" style={{display: popup ? "flex" : "none", backgroundColor:  !popup && '#00000000', transition: "0.5s", scale: popup ? "1" : "0"}}>
            <div className="container popup_color" style={{display: "block"}}>
                <div className="padding-20 d-flex"><img src="../images/question.png" style={{margin: "20px auto 0 auto"}} alt="" /></div>
                <div className="justify-center  d-flex betting_modal_text"><span style={{width: "100%", textAlign: "center"}}>로그 아웃하시겠습니까?</span></div>
                <div className=" d-flex w-100 justify-content-center padding-15 betting_modal_text">
                    <span className="popup-btn" onClick={onLogout}>네</span>
                    <span className="popup-btn" onClick={onPopup}>아니오</span>
                </div>
            </div>
        </div>

      </div>);
};

const mapStateToProps = state => ({
    isAuthenticated: state.user.isAuthenticated,
    user: state.user.data,
    page: state.page.pageInfo,
    unreadNotes: state.more.message.unreadNotes
  });

export default connect(mapStateToProps, { logoutUser })(Headbar);


// WEBPACK FOOTER //
// ./src/components/Layout/MyInfo.js